import {
    PRODUCT_LIST_REQUEST,
    PRODUCT_LIST_SUCCESS,
    PRODUCT_LIST_FAIL,
    PRODUCT_DETAILS_REQUEST,
    PRODUCT_DETAILS_SUCCESS,
    PRODUCT_DETAILS_FAIL,
    BOOKMARKED_PRODUCT_LIST_REQUEST,
    BOOKMARKED_PRODUCT_LIST_REQUEST_SUCCESS,
    BOOKMARKED_PRODUCT_LIST_REQUEST_FAILED,
    PRODUCT_DEATIL_ADMIN_REQUEST,
    PRODUCT_DEATIL_ADMIN_SUCCESS,
    PRODUCT_DEATIL_ADMIN_FAIL,
    PRODUCT_DEATIL_ADMIN_RESET,
    PRODUCT_DETAILS_RESET,
} from './productConstants'

export const productDetailsReducer = (state = {
    loading: true,
    error: '',
    id: 0,
    mainCategoryId: 0,
    mainCategory: '',
    subCategoryId: 0,
    subCategory: '',
    secondarySubCategoryId: 0,
    secondarySubCategory: '',
    thumbnailImgURL: '',
    imgURL: '',
    title: '',
    price250: 0,
    price500: 0,
    price1000: 0,
    starRating: 0.0,
    bookmarked: false,
    numberInStock250: 0,
    numberInStock500: 0,
    numberInStock1000: 10,
    propertiesTitle: '',
    propertiesText: '',
    bulkSale: false,
    arContent: false,
    relatedProducts: []
}, action) => {
    switch (action.type) {
        case PRODUCT_DETAILS_REQUEST:
            return {
                loading: true,
                ...state
            }
        case PRODUCT_DETAILS_SUCCESS:
            return {
                loading: false,
                id: action.payload.id,
                secondarySubCategoryId: action.payload.secondarySubCategoryId,
                thumbnailImgURL: action.payload.thumbnailImgURL,
                imgURL: action.payload.imgURL,
                title: action.payload.title,
                price250: action.payload.price250,
                price500: action.payload.price500,
                price1000: action.payload.price1000,
                starRating: action.payload.starRating,
                bookmarked: action.payload.bookmarked,
                numberInStock250: action.payload.numberInStock250,
                numberInStock500: action.payload.numberInStock500,
                numberInStock1000: action.payload.numberInStock1000,
                propertiesTitle: action.payload.propertiesTitle,
                propertiesText: action.payload.propertiesText,
                bulkSale: action.payload.bulkSale,
                arContent: action.payload.arContent,
                relatedProducts: action.payload.relatedProducts,
            }
        case PRODUCT_DETAILS_FAIL:
            return { loading: false, error: action.payload }
        case PRODUCT_DETAILS_RESET:
            return { loading: true }
        default:
            return state
    }
}

export const productListReducer = (state = {
    mainCategories: [],
    productList: [],
    secondarySubCategories: [],
    outOfStock: true,
    subCategories: [],
    totalPages: 0,
    priceMin: 0,
    priceMax: 0,
}, action) => {
    switch (action.type) {
        case PRODUCT_LIST_REQUEST:
            return {
                loading: true,
                ...state
            }
        case PRODUCT_LIST_SUCCESS:
            return {
                loading: false,
                mainCategories: action.payload.mainCategories,
                productList: action.payload.productList,
                secondarySubCategories: action.payload.secondarySubCategories,
                outOfStock: action.payload.outOfStock,
                subCategories: action.payload.subCategories,
                totalPages: action.payload.totalPages,
                priceMin: action.payload.priceMin,
                priceMax: action.payload.priceMax
            }
        case PRODUCT_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const bookmaredProductsListReducer = (state = {
    bookmarks: [],
    totalPages: 0,
}, action) => {
    switch (action.type) {
        case BOOKMARKED_PRODUCT_LIST_REQUEST:
            return {
                bLoading: true,
                ...state
            }
        case BOOKMARKED_PRODUCT_LIST_REQUEST_SUCCESS:
            return {
                bLoading: false,
                bookmarks: action.payload.bookmarks,
                totalPages: action.payload.totalPages,
            }
        case BOOKMARKED_PRODUCT_LIST_REQUEST_FAILED:
            return { bLoading: false, bError: action.payload }
        default:
            return state
    }
}

export const getDetailProductReducer = (
    state = {
        loading: true,
        id: 0,
        imgURL: "",
        title: "",
        UnitPrice: 0,
        starRating: 0.0,
        numberInStock250: 0,
        numberInStock500: 0,
        numberInStock1000: 10,
        propertiesTitle: "",
        propertiesText: "",
    },
    action
) => {
    switch (action.type) {
        case PRODUCT_DEATIL_ADMIN_REQUEST:
            return {
                loading: true,
                ...state,
            };
        case PRODUCT_DEATIL_ADMIN_SUCCESS:
            return {
                loading: false,
                id: action.payload.id,
                imgURL: action.payload.imgURL,
                title: action.payload.title,
                arTitle: action.payload.arTitle,
                arPropertiesTitle: action.payload.arPropertiesTitle,
                arPropertiesText: action.payload.arPropertiesText,
                mainCategoryId: action.payload.mainCategoryId,
                subCategoryId: action.payload.subCategoryId,
                secondarySubCategoryId: action.payload.secondarySubCategoryId,
                UnitPrice: action.payload.unitPrice,
                arUnitPrice: action.payload.arUnitPrice,
                starRating: action.payload.starRating,
                numberInStock250: action.payload.numberInStock250,
                numberInStock500: action.payload.numberInStock500,
                numberInStock1000: action.payload.numberInStock1000,
                propertiesTitle: action.payload.propertiesTitle,
                propertiesText: action.payload.propertiesText,
                bulkSale: action.payload.bulkSale,
            };
        case PRODUCT_DEATIL_ADMIN_FAIL:
            return { loading: false, error: action.payload };
        case PRODUCT_DEATIL_ADMIN_RESET:
            return {
                id: "",
                imgURL: "",
                title: "",
                arTitle: "",
                arPropertiesTitle: "",
                arPropertiesText: "",
                mainCategoryId: "",
                subCategoryId: "",
                secondarySubCategoryId: "",
                unitPrice: "",
                arUnitPrice: "",
                starRating: "",
                numberInStock250: "",
                numberInStock500: "",
                numberInStock1000: "",
                propertiesTitle: "",
                propertiesText: "",
                bulkSale: ""
            };
        default:
            return state;
    }
}